import {
  required,
  unique,
  shape,
  items,
  concatFailure,
  fromParent,
  when,
  lessThan,
  greaterThan,
  stopOnFirstFailure,
  fromModel
} from '@totalsoft/pure-validations';
import { numericPropertyType } from 'constants/propertyType';
import { isValidDateFormat } from 'utils/simple-validations';

export const questionnaireValidator = fromModel(model =>
  shape({
    code: required,
    name: required,
    validFrom: [required, lessThan(model.validTo) |> when(Boolean(model.validTo)), isValidDateFormat] |> stopOnFirstFailure,
    validTo: [greaterThan(model.validFrom) |> when(Boolean(model.validFrom)), isValidDateFormat] |> stopOnFirstFailure,
    filterFormula: required
  })
);

export const questionValidator = concatFailure(
  unique(x => x.orderNo || {}, 'Questionnaire.Question.Validators.OrderIdUnique'),
  unique(x => x.questionCode || {}, 'Questionnaire.Question.Validators.QuestionCode'),
  unique(x => (x.questionName || {}) + (x.questionTypeId || {}), 'Questionnaire.Question.Validators.QuestionNameWithTypeId'),
  items(
    shape({
      orderNo: required,
      questionCode: required,
      questionName: required,
      questionTypeId: required,
      numericPrecision: fromParent(parent => required |> when(parent.questionTypeId === numericPropertyType)),
      questionDetails: items(shape({ questionValue: required, questionDetailCode: required }))
    })
  )
);

export const questionActionValidator = concatFailure(
  unique(x => x.questionActionTypeId || {}, 'Questionnaire.Question.Validators.ActionTypeUnique'),
  items(
    shape({
      formula: required,
      questionActionTypeId: required
    })
  )
);
